<div class="flex flex-col flex-auto min-w-0">
    <div class="flex flex-auto overflow-hidden">
        <div class="flex flex-col flex-auto sm:mb-18 overflow-hidden sm:overflow-y-auto border">
            <div class="grid">
                <div class="table-grid-pieces z-10 sticky top-0 grid gap-4 py-4 px-6 md:px-8 shadow text-md font-semibold text-secondary bg-gray-50 dark:bg-black dark:bg-opacity-5">
                    <div>Nom de la pièce</div>
                    <div class="text-left">Étage</div>
                    <div class="right-0">Détail</div>
                </div>
                <ng-container *ngFor="let piece of pieces; trackBy: trackByFn">
                    <div class="table-grid-pieces grid items-center gap-4 py-3 px-6 md:px-8">
                        <div class="">{{piece.nom_piece}}</div>
                        <div>{{getEtage(piece)}}</div>
                        <div class="right-0">
                            <button (click)="editPiece.emit(piece)" class="min-w-10 min-h-7 h-7 px-2 leading-6" mat-stroked-button>
                                <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:pencil'"></mat-icon>
                            </button>
                            <button class="min-w-10 min-h-7 h-7 px-2 leading-6" mat-stroked-button (click)="delete(piece.id)" *ngIf="isAdmin">
                                <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:trash'"></mat-icon>
                            </button>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>
